<template>
 <div class="wrapper">
    
      <div class="section section-signup page-header header-filter" :style="headerStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
            >
          <div>
            <md-button
              class=" md-danger md-round btnA"
              color="red"
              href="#/basic"
              >Retour</md-button
            >

            <md-button @click="generateReport" class=" md-danger md-round btnA">
                      Extraction
                    </md-button>
          </div>
          <div id="element-to-convert">
            <md-table
              v-model="activites"
              md-sort="date"
              md-sort-order="asc"
              md-card
              md-fixed-header
              class="tab"
              ref="table"
            >
              <md-table-toolbar ref="toolbar">
               
                <div class="md-toolbar-row">
                    
                    
                  <div class=" md-toolbar-section-start">
                    <h2 class="md-title">
                      <b> {{ this.user.nom + " " + this.user.prenom }} </b>
                    </h2>
                  </div>

                  <div class="toobarTable md-toolbar-section-start">
                    <p class="md-title">
                      <b>  Heure total : {{ total }}</b>
                    </p>
                  </div>
                
                  <md-field md-clearable class="md-toolbar-section-end">
                    <md-input
                      placeholder="Search by date..."
                      v-model="search"
                      @input="searchOnTable"
                    />
                  </md-field>
                </div>
                
                 
                
              </md-table-toolbar>

              <md-table-empty-state
                md-label="No users found"
                :md-description="
                  `No user found for this '${search}' query. Try a different search term or create a new user.`
                "
              >
                <md-button class="md-primary md-raised" @click="newUser"
                  >Create New User</md-button
                >
              </md-table-empty-state>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Date" md-sort-by="date">{{
                  item.date
                }}</md-table-cell>
                <md-table-cell md-label="Debut" md-sort-by="nombreD">{{
                  item.heuredebut
                }}</md-table-cell>
                <md-table-cell md-label="Fin" md-sort-by="nombreF">{{
                  item.heurefin
                }}</md-table-cell>
                <md-table-cell md-label="Total" md-sort-by="nombreT">{{
                  item.nombreT

                  /*   item.moment.duration(item.heurefin.diff(item.heuredebut)).as("hours") */
                }}</md-table-cell>
                <md-table-cell md-label="Action" md-sort-by="action">
                  <router-link :to="'/session/' + item.id"
                    ><md-button class=" md-simple md-danger ">
                      <md-icon>update</md-icon>
                    </md-button>
                  </router-link>
                </md-table-cell>

                <!--  <md-button class="md-success ">
            Détails
          </md-button> -->
              </md-table-row>
            </md-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../http-common";
import SessionUser from "./SessionUser.vue";
import moment from "moment";
import * as XLSX from "xlsx/xlsx.mjs";
const toLower = (text) => {
  return text.toString().toLowerCase();
};

export default {
  bodyClass: "login-page",
  name: "TableSearch",
  data: () => ({
    search: "",
    searched: [],
    activites: [],
    total: 0,
  }),
  props: {
    header: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  computed: {
    ...mapGetters(["user"]),

    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
  methods: {
    newUser() {
      window.alert("Noop");
    },

    generateReport() {
      /* flatten objects */
      let rows = this.activites.map((row) => ({
        nom: row.nom,
        date: row.date,
        heuredebut: row.heuredebut,
        heurefin: row.heurefin,
        nombreT: row.nombreT,
      }));

      rows.unshift({
        nom: "Nom",
        date: "Date",
        heuredebut: "Heure de début",
        heurefin: "Heure de fin",
        nombreT: "Nombre Total",
      });

      /* generate worksheet and workbook */
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet);

      /* fix headers */
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [[this.user.nom, this.user.prenom, this.total, "", ""]],
        {
          origin: "A1",
        }
      );

      /* calculate column width */
      const max_width = rows.reduce((w, r) => Math.max(w, r.nom.length), 20);
      worksheet["!cols"] = [
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];

      /* create an XLSX file and try to save to repport.xlsx */
      XLSX.writeFile(workbook, "repport.xlsx", { compression: true });
    },

    getUsers() {
      axios
        .get("/activites")
        .then((response) => {
          this.activites = response.data.activites;
          this.total = response.data.total;
         // console.log(response);
        })
        .catch((error) 
         //=> console.log(error.message)
        );
      //console.log("Recupérations des utilisateurs");
    },

    updateUsers() {
      axios
        .put(`/${this.id}`, this.activites)
        .then((response) => {
         // console.log(response);
        })
        .catch((error)
         // => console.log(error.message)
        );
      //
     // console.log("Modification des utilisateurs");
    },

    CalculNombreTotal(debut, fin) {
      return Math.round(
        moment
          .duration(moment(fin, "HH:mm").diff(moment(debut, "HH:mm")))
          .as("hours")
      );
    },

    searchOnTable() {
      // this.getUsers();
    //  console.log("this.search", this.search);
      this.searched = this.searchByName(this.activites, this.search);
    },
    searchByName(items, term) {
     // console.log("items, term", items, term);
      let result = [];
      if (term) {
        result = items.filter((item) =>
          toLower(item.prenom).includes(toLower(term))
        );
      }
      this.activites = result;
    },
  },

  created() {
    this.getUsers();
    this.searched = this.activites;
  },
};
</script>

<style lang="scss" scoped>
/* .md-field {
  max-width: 300px;
}
.btnA {
  margin-top: 50px;
  margin-bottom: -200px;
}
.tab {
  padding-top: -60px;
} */
</style>
